import AbstractPromotionsService from './abstract-promotions-service';
import PromotionsDataDescriptor from 'services/promotions/descriptor.js';
import { promotionContainersProvider, promotionsProvider } from 'services/promotions/provider';
import channelFactory from 'services/common/content/content-channel-factory.js';

export const getPromotionsChannel = () =>
    channelFactory.getChannel(promotionsProvider, PromotionsDataDescriptor.DATA_TYPES.PROMOTIONS);

export const getPromotionContainersChannel = () =>
    channelFactory.getChannel(
        promotionContainersProvider,
        PromotionsDataDescriptor.DATA_TYPES.CMS_CONTAINER
    );

/**
 * Class offering the possibility access promotions storable using push messaging mechanism.
 *
 * @class PushPromotionsService
 * @extends Mojito.Services.Promotions.AbstractPromotionsService
 * @memberof Mojito.Services.Promotions
 */
export default class PushPromotionsService extends AbstractPromotionsService {
    subscribe(options, onMessage) {
        const { clientId, channels } = options;
        getPromotionsChannel().subscribe(channels, clientId, onMessage);
    }

    subscribeContainers(options, onMessage) {
        const { clientId, channels } = options;
        getPromotionContainersChannel().subscribe(channels, clientId, onMessage);
    }

    unsubscribe(options) {
        const { clientId, channels } = options;
        getPromotionsChannel().unsubscribe(channels, clientId);
    }

    unsubscribeContainers(options) {
        const { clientId, channels } = options;
        getPromotionContainersChannel().unsubscribe(channels, clientId);
    }

    unsubscribeAllContainers(clientId) {
        getPromotionContainersChannel().unsubscribeAll(clientId);
    }

    reset() {
        getPromotionsChannel().dispose();
        getPromotionContainersChannel().dispose();
    }
}

/**
 * PushPromotionsService class instance.
 *
 * @name pushPromotionsService
 * @memberof Mojito.Services.Promotions
 */
export const pushPromotionsService = new PushPromotionsService();
